_options$browser